import { motion } from 'framer-motion';

export const FadeUp = ({ children, delay = 0, className = '', y = 30 }) => (
  <motion.div
    className={className}
    initial={{ opacity: 0, y }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, amount: 0.15 }}
    transition={{ duration: 0.75, delay, ease: [0.22, 1, 0.36, 1] }}
  >
    {children}
  </motion.div>
);

export const lineReveal = {
  hidden: {},
  visible: (i = 0) => ({
    transition: { staggerChildren: 0.11, delayChildren: 0.12 + i * 0.08 },
  }),
};

export const lineChild = {
  hidden: { y: '115%' },
  visible: { y: '0%', transition: { duration: 0.95, ease: [0.22, 1, 0.36, 1] } },
};

export const MaskedLine = ({ children, as: Tag = 'span', className = '' }) => (
  <Tag className={`block overflow-hidden ${className}`}>
    <motion.span className="block will-change-transform" variants={lineChild}>
      {children}
    </motion.span>
  </Tag>
);
